var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineIconBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 6.25033C1.66675 5.09973 2.59949 4.16699 3.75008 4.16699H10.0001C11.1507 4.16699 12.0834 5.09973 12.0834 6.25033V14.5837C12.0834 15.7343 11.1507 16.667 10.0001 16.667H3.75008C2.59949 16.667 1.66675 15.7343 1.66675 14.5837V6.25033Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7426 7.40197C14.3897 7.57842 14.1667 7.93911 14.1667 8.33366V12.5003C14.1667 12.8949 14.3897 13.2556 14.7426 13.432L16.8259 14.4737C17.1488 14.6351 17.5323 14.6179 17.8394 14.4281C18.1465 14.2383 18.3334 13.903 18.3334 13.542V7.29199C18.3334 6.93098 18.1465 6.5957 17.8394 6.4059C17.5323 6.2161 17.1488 6.19885 16.8259 6.3603L14.7426 7.40197Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineIconBlack);
export default __webpack_public_path__ + "static/media/online-icon-black.e5b78fc85694f686ca1493162724b839.svg";
export { ForwardRef as ReactComponent };